export default __webpack_public_path__ + "static/media/rinsonChory.b803d0c8.jpeg";